<div [ngClass]="{'overlay': backdropActive, 'transparent': transparent }" smClickStopPropagation></div>
